import type { UsageStatus } from "../types";

export function calculateBudgetPercentage(costEstimateEur: number, budgetLimitEur: number): number {
  if (budgetLimitEur <= 0) {
    return 100;
  }

  return Math.max(0, (costEstimateEur / budgetLimitEur) * 100);
}

export function getUsageStatus(costEstimateEur: number, budgetLimitEur: number): UsageStatus {
  const percentage = calculateBudgetPercentage(costEstimateEur, budgetLimitEur);

  if (percentage >= 100) {
    return "paused_budget_reached";
  }

  if (percentage >= 90) {
    return "warning_90";
  }

  if (percentage >= 70) {
    return "warning_70";
  }

  return "active";
}

export function calculateUsageStatus(usedEur: number, limitEur: number): UsageStatus {
  return getUsageStatus(usedEur, limitEur);
}

export function canRunFutureAiAction(usageStatus: UsageStatus): boolean {
  return usageStatus !== "paused_budget_reached";
}
